const STEPS = [
	{
		number: 1,
		title: "Connect provider",
		body: "Paste a read-only Stripe or Creem API key. We never touch payouts or customer data.",
	},
	{
		number: 2,
		title: "We calculate MRR",
		body: "AgentMRR pulls your subscription data and computes your monthly recurring revenue.",
	},
	{
		number: 3,
		title: "Badge appears",
		body: "Your verified MRR goes live on the leaderboard with a provider-backed badge.",
	},
] as const;

export function VerificationExplainer() {
	return (
		<div className="grid gap-px border border-border bg-border md:grid-cols-3">
			{STEPS.map((step) => (
				<div key={step.number} className="flex flex-col gap-3 bg-card p-5">
					<div className="flex items-center gap-2">
						<span className="inline-flex size-7 items-center justify-center border border-brand/40 bg-brand-soft font-mono font-normal text-sm text-brand">
							{String(step.number)}
						</span>
					</div>
					<div>
						<p className="font-mono text-sm uppercase tracking-widest text-foreground">
							{step.title}
						</p>
						<p className="mt-1.5 text-pretty text-base text-muted-foreground leading-normal">
							{step.body}
						</p>
					</div>
				</div>
			))}
		</div>
	);
}

export function VerificationExplainerCompact() {
	return (
		<div className="border border-border bg-muted/30 p-3 space-y-2">
			<p className="font-mono text-sm uppercase tracking-[0.14em] text-muted-foreground">
				&gt; How it works
			</p>
			<div className="flex flex-col gap-1.5">
				{STEPS.map((step) => (
					<div key={step.number} className="flex items-start gap-2">
						<span className="mt-0.5 inline-flex size-4 shrink-0 items-center justify-center border border-brand/40 bg-brand-soft font-mono text-sm text-brand leading-none">
							{step.number}
						</span>
						<span className="text-sm text-muted-foreground leading-[1.4]">
							<span className="font-normal text-foreground">{step.title}</span>
							{": "}
							{step.body}
						</span>
					</div>
				))}
			</div>
			<p className="font-mono text-sm uppercase tracking-[0.12em] text-muted-foreground">
				Read-only · no payouts · no customer PII
			</p>
		</div>
	);
}
